// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { valueAddedServicesStyles } from "@awc/App/Widgets/ValueAddedServices/ValueAddedServices";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

valueAddedServicesStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            justify-content: center;
            margin-bottom: 16px;
            ${xScreen("lte", "sm")} {
                justify-content: center;
            }
        `,
    },
    title: {
        variant: "h2",
        css: css`
            margin-bottom: 0;
            text-align: center;
        `,
    },
};
valueAddedServicesStyles.serviceImagesContainer = {
    css: css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        gap: 16px 20px;
        margin: 48px auto 0;
        ${({ maxContainerWidth }: any) =>
            maxContainerWidth &&
            `
            max-width: ${maxContainerWidth}px;
        `}
    `,
};

valueAddedServicesStyles.description = {
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.regular,
    lineHeight: fontConfig.lineHeight.regular,
    css: css`
        text-align: center;
        margin-bottom: 0;
        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};

valueAddedServicesStyles.image = {
    css: css`
        width: auto;
        ${({ imageMaxHeight }: any) =>
            imageMaxHeight &&
            `
             height: ${imageMaxHeight}px;
             max-height: ${imageMaxHeight}px;
        `}
    `,
};
valueAddedServicesStyles.imageClickable = {
    css: css`
        justify-content: center;
    `,
};
